import { useContext } from "react";
import { TransactionContext } from "contexts";

export default () => useContext(TransactionContext);
